import { useState } from 'react'
import DataGridSkeleton from '../../shared/components/DataGridSkeleton';
import { DataGrid } from '@mui/x-data-grid';
import CustomPagination from '../../shared/utils/CustomPagination';
import { Typography } from '@mui/material';
import { CoordinatorListUnderZoneHead } from '../commonfile/CoordinatorListUnderZoneHead';
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox';
import { useDialog } from '../../shared/hook/useDialog';
import { ApartmentListUnderZoneHead } from '../commonfile/ApartmentListUnderZoneHead';
import CustomDivider from '../../shared/utils/CustomDivider';

const ZoneHeadListTable = ({ zoneHeadRow, isLoading }) => {
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const { open, handleClickOpen, handleClose } = useDialog();
    const [selectedRow, setSelectedRow] = useState({})
    const viewSelectRow = (row) => {
        setSelectedRow(row)
        handleClickOpen()
    };
    const zoneHeadColumn = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "firstname",
            headerName: "First Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params?.row?.role === "student" ? params?.row?.lastname : params.value}</Typography>,
        },

        {
            field: "lastname",
            headerName: "Last Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params?.row?.role === "student" ? "" : params.value}</Typography>,
        },
        {
            field: "role",
            headerName: "Role",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "username",
            headerName: "Username",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "email",
            headerName: "Email",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "mobile",
            headerName: "Mobile",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        }
    ];
    return (
        <>

            {isLoading ? (
                <DataGridSkeleton rowsNum={10} />
            ) : (
                <DataGrid
                    rows={zoneHeadRow}
                    columns={zoneHeadColumn}
                    pagination
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={[10]}
                    disableRowSelectionOnClick={true}
                    onRowClick={(params) => viewSelectRow(params.row)}
                    slots={{
                        pagination: () => (
                            <CustomPagination
                                paginationModel={paginationModel}
                                setPaginationModel={setPaginationModel}
                                totalRows={zoneHeadRow?.length || 0}
                                pageSize={paginationModel.pageSize}
                            />
                        ),
                    }}
                />
            )}

            <MainDialogBox open={open} handleClose={handleClose} width={"60%"}>
                <Typography variant="body1" my={2}>Coordinator List</Typography>
                <CoordinatorListUnderZoneHead id={selectedRow?.id} />
                <CustomDivider />
                <Typography variant="body1" my={2}>Apartment List</Typography>
                <ApartmentListUnderZoneHead id={selectedRow?.id} />
            </MainDialogBox>
        </>
    )
}

export default ZoneHeadListTable